import { Section, Shimmer } from '@soteria/design-system-ve';

import * as styles from './AuditReportPage.css';
import * as shimmerStyles from './AuditReportPageShimmer.css';

/**
 * Shimmer loading component for AuditReportPage content section
 * Matches the structure of the actual report content with shimmer effects
 */
export function AuditReportPageShimmer() {
  return (
    <div className={styles.contentSection}>
      <div className={styles.contentContainer}>
        <Section spacing="large">
          {/* Report Title Shimmer */}
          <div className={shimmerStyles.shimmerTitle}>
            <Shimmer style={{ width: '200px', height: '32px', borderRadius: '4px' }} />
          </div>

          {/* Overall Performance Metrics Section Shimmer */}
          <Section background="secondary" spacing="large">
            <div className={styles.sectionContentWrapper}>
              {/* Section Title Shimmer */}
              <div className={shimmerStyles.shimmerSectionTitle}>
                <Shimmer style={{ width: '240px', height: '24px', borderRadius: '4px' }} />
              </div>

              {/* Metrics Grid Shimmer */}
              <div className={styles.metricsGrid}>
                {[1, 2, 3, 4].map(index => (
                  <div key={`metric-${index}`} className={styles.metricCard}>
                    {/* Metric Label Shimmer */}
                    <div className={shimmerStyles.shimmerMetricLabel}>
                      <Shimmer style={{ width: '80px', height: '12px', borderRadius: '4px' }} />
                    </div>
                    {/* Metric Value Shimmer */}
                    <Shimmer style={{ width: '60px', height: '28px', borderRadius: '4px' }} />
                  </div>
                ))}
              </div>
            </div>
          </Section>

          {/* Label Comparison Analysis Section Shimmer */}
          <Section background="primary" spacing="large">
            <div className={styles.sectionContentWrapper}>
              {/* Section Title Shimmer */}
              <div className={shimmerStyles.shimmerSectionTitle}>
                <Shimmer style={{ width: '220px', height: '24px', borderRadius: '4px' }} />
              </div>

              {/* Comparison Grid Shimmer */}
              <div className={styles.comparisonGrid}>
                {[1, 2, 3, 4].map(index => (
                  <div key={`comparison-${index}`} className={styles.comparisonCard}>
                    {/* Comparison Label Shimmer */}
                    <div className={shimmerStyles.shimmerMetricLabel}>
                      <Shimmer style={{ width: '120px', height: '12px', borderRadius: '4px' }} />
                    </div>
                    {/* Comparison Value Shimmer */}
                    <Shimmer style={{ width: '80px', height: '24px', borderRadius: '4px' }} />
                  </div>
                ))}
              </div>
            </div>
          </Section>

          {/* Performance by Label Section Shimmer */}
          <Section background="secondary" spacing="large">
            <div className={styles.sectionContentWrapper}>
              {/* Section Title Shimmer */}
              <div className={shimmerStyles.shimmerSectionTitle}>
                <Shimmer style={{ width: '180px', height: '24px', borderRadius: '4px' }} />
              </div>

              {/* Data Table Shimmer */}
              <div className={styles.labelPerformanceSection}>
                {/* Table Header Shimmer */}
                <div className={shimmerStyles.shimmerTableHeader}>
                  <Shimmer style={{ width: '60px', height: '16px', borderRadius: '4px' }} />
                  <Shimmer style={{ width: '70px', height: '16px', borderRadius: '4px' }} />
                  <Shimmer style={{ width: '50px', height: '16px', borderRadius: '4px' }} />
                  <Shimmer style={{ width: '60px', height: '16px', borderRadius: '4px' }} />
                  <Shimmer style={{ width: '70px', height: '16px', borderRadius: '4px' }} />
                </div>

                {/* Table Rows Shimmer */}
                {[1, 2, 3, 4, 5].map(index => (
                  <div key={`table-row-${index}`} className={shimmerStyles.shimmerTableRow}>
                    <Shimmer style={{ width: '90px', height: '16px', borderRadius: '4px' }} />
                    <Shimmer style={{ width: '50px', height: '16px', borderRadius: '4px' }} />
                    <Shimmer style={{ width: '50px', height: '16px', borderRadius: '4px' }} />
                    <Shimmer style={{ width: '50px', height: '16px', borderRadius: '4px' }} />
                    <Shimmer style={{ width: '50px', height: '16px', borderRadius: '4px' }} />
                  </div>
                ))}
              </div>
            </div>
          </Section>

          {/* Footer Shimmer */}
          <Section spacing="large">
            <div className={styles.reportFooter}>
              <Shimmer style={{ width: '250px', height: '16px', borderRadius: '4px' }} />
            </div>
          </Section>
        </Section>
      </div>
    </div>
  );
}
